// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__sLE3l","title":"InfoRow_title__26jtB"};